import { Icon } from "./Icon.tsx";

/** Paired with PlayIcon.tsx for the results-animation control bar's play/pause toggle. */
export function PauseIcon() {
  return (
    <Icon>
      <path d="M7 4h4v16H7zM13 4h4v16h-4z" fill="currentColor" stroke="none" />
    </Icon>
  );
}
